import { useContext, useState } from 'react';

import Dialog from '@mui/material/Dialog';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import AddIcon from '@mui/icons-material/Add';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ReportIcon from '@mui/icons-material/Report';
import BorderColorIcon from '@mui/icons-material/BorderColor';

import { SwitchMui } from './switchMui';
import { ContextApi } from '../../context/contextApi';

import styles from './style.module.scss'

export function SelectOrRegister({
    label,
    titleInput,
    dataRegions,
    ufSelected,
    selectedRegion,
    setSelectedRegion,
    error
}) {
    const { cadastrarRegiao, deletarRegiao, editarRegiao } = useContext(ContextApi)
    const [showSelectOrRegisterRegion, setShowSelectOrRegisterRegion] = useState(false);
    const [showInnerRegion, setShowInnerRegion] = useState(false);
    const [nameNewRegion, setNameNewRegion] = useState('');
    const [showConfirmExclude, setShowConfirmExclude] = useState(false);
    const [infoExcludeRegion, setInfoExcludeRegion] = useState({
        RegionId: 0,
        nameRegion: '',
        lengthCameras: 0
    });
    const [dataEditRegion, setDataEditRegion] = useState({
        editar: false,
        idRegion: 0,
        ufRegion: ufSelected,
        nameRegion: ''
    })

    let regionFilterUf = dataRegions?.filter(regiaoUf => regiaoUf.estado_sigla === ufSelected)
    
    function handleCloseInnerRegion() {
        setShowInnerRegion(false);
    }

    async function innerNewRegion() {
        await cadastrarRegiao({
            estado_sigla: ufSelected,
            nome: nameNewRegion,
            slug: "",
        })
        setShowInnerRegion(false);
    }

    async function editThisRegion() {
        await editarRegiao(dataEditRegion.idRegion, {
            estado_sigla: ufSelected,
            nome: dataEditRegion.nameRegion,
        })
        setShowInnerRegion(false);
    }

    async function deleteRegiao(idRegion) {
        await deletarRegiao(idRegion)
        setShowConfirmExclude(false);
    }

    return (
        <div>
            <div className={error ? styles.boxLabelError : styles.boxLabel}>
                <label>{label}</label>
                {error && <span>*Informação obrigatória</span>}
            </div>
            {ufSelected &&
            <div 
            className={styles.containerAllSelectOrRegister}
            onClick={() => setShowSelectOrRegisterRegion(!showSelectOrRegisterRegion)}
            >
                <span className={styles.titleInput}>{selectedRegion ? selectedRegion.regionSelected : titleInput}</span>
                {!showSelectOrRegisterRegion && ufSelected ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
            </div>}
            {showSelectOrRegisterRegion &&
            ufSelected &&
            <>
                <div className={styles.boxOptionsForSelect}>
                    {regionFilterUf.map((region) => {
                        return (
                            <div 
                            kay={region.id}
                            className={styles.boxLine}
                            >
                                <div className={styles.lineNameAndIcons}>
                                    <span 
                                    className={styles.lineOptions}
                                    onClick={() => {
                                        setSelectedRegion({
                                        idSelected: region.id,
                                        regionSelected: region.nome
                                    })
                                    setShowSelectOrRegisterRegion(false);
                                }}
                                    >
                                        {region.nome}
                                    </span>
                                    <div className={styles.boxIcons}>
                                        <div 
                                        onClick={() => {
                                            setDataEditRegion({
                                                editar: true,
                                                idRegion: region.id,
                                                ufRegion: ufSelected,
                                                nameRegion: region.nome
                                            });
                                            setShowInnerRegion(true);
                                        }}
                                        >
                                            <BorderColorIcon />
                                        </div>
                                        <div
                                        onClick={() => {
                                            setInfoExcludeRegion({
                                                RegionId: region.id,
                                                nameRegion: region.nome,
                                                lengthCameras: region.cameras?.length
                                            })
                                            setShowConfirmExclude(true);
                                        }}
                                        >
                                            <DeleteForeverIcon />
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.dividerLine}></div>
                            </div>
                        )
                    })}
                </div>
                <div 
                className={styles.boxRegisterNewRegion}
                onClick={() => {
                    setDataEditRegion({
                        editar: false,
                        idRegion: 0,
                        ufRegion: ufSelected,
                        nameRegion: ''
                    });
                    setShowInnerRegion(true);               
                }}
                >
                    <span>Cadastrar nova região</span>
                    <AddIcon />
                </div>
            </>
            }
            {!showSelectOrRegisterRegion &&
            !ufSelected &&
            <div 
            className={styles.containerAllSelectOrRegisterNotUf}
            >
                <span className={styles.titleInput}>Primeiro você precisa selecionar um estado/UF</span>
                <ReportIcon />
            </div>
            }
            <Dialog
            onClose={handleCloseInnerRegion} 
            open={showInnerRegion}
            >
                <div className={styles.containerInputNewRegion}>
                    <div className={styles.boxTitleModalInputNewRegion}>
                        <span>
                            {dataEditRegion.editar ? 'Editar Região' : 'Cadastrar nova região'}
                        </span>
                    </div>
                    <div>
                        <div className={styles.boxInputTextNewRegion}>
                            <label>Nome da região</label>
                            {dataEditRegion.editar && 
                                <input 
                                type="text"
                                name='region'
                                value={dataEditRegion.nameRegion}
                                onChange={(e) => setDataEditRegion({
                                    ...dataEditRegion,
                                    nameRegion: e.target.value
                                })}
                                />
                            }
                            {!dataEditRegion.editar && 
                                <input 
                                type="text"
                                name='region'
                                onChange={(e) => setNameNewRegion(e.target.value)}
                                />
                            }
                        </div>
                    </div>
                    <div 
                    className={styles.boxBTNNewRegion}
                    onClick={() => dataEditRegion.editar ? editThisRegion() : innerNewRegion()}
                    >
                        <span>
                            {dataEditRegion.editar ? 'Editar região' : 'Criar região'}
                        </span>
                    </div>
                </div>
            </Dialog>
            <Dialog
            onClose={() => setShowConfirmExclude(false)}
            open={showConfirmExclude}
            >
                {(infoExcludeRegion.lengthCameras >= 1) && 
                    <Alert 
                    variant="filled" 
                    severity="warning"
                    action={
                        <Button 
                        color="inherit" 
                        size="small"
                        onClick={() => setShowConfirmExclude(false)}
                        >
                          Ok
                        </Button>
                      }
                    >
                      Esta região esta vinculada a outras {infoExcludeRegion.lengthCameras} câmeras, por isso não pode ser excluída!
                    </Alert>
                }
                {infoExcludeRegion.lengthCameras === 0 && 
                <Alert 
                variant="filled" 
                severity="error"
                action={
                    <Button 
                    color="inherit" 
                    size="small"
                    onClick={() => deleteRegiao(infoExcludeRegion?.RegionId)}
                    >
                      Excluir
                    </Button>
                  }
                >
                  Deseja excluir de forma permanente a região {infoExcludeRegion?.nameRegion}?
                </Alert>}
            </Dialog>
        </div>
    )
}